<template>
  <img v-bind="parseAttributeString" />
</template>

<script>
import FirstSpiritContentCreatorMixin from '../../shared/mixins/FirstSpiritContentCreatorMixin';

export default {
  mixins: [FirstSpiritContentCreatorMixin],
};
</script>
